import { render } from "./BlackListView.vue?vue&type=template&id=c52696a8&scoped=true"
import script from "./BlackListView.vue?vue&type=script&lang=js"
export * from "./BlackListView.vue?vue&type=script&lang=js"

import "./BlackListView.vue?vue&type=style&index=0&id=c52696a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c52696a8"]])

export default __exports__